import { h } from '@stencil/core';
import { pesIconSizes } from '@pes-ui/utils';
import { ItemType } from './utils';
import { isBrowser } from '../../../globals/utils';
const ZoomInfoStatus = (props) => {
  if (props.zoomOpen || props.showHint) {
    return (h("div", { class: "zoom__info-status zoom__info-status--hovered" }, isBrowser() && h("pes-icon", { size: pesIconSizes.MICRO }, "presentation_mode")));
  }
  if (props.selectedType === ItemType.GEOMETRIC
    || props.selectedType === ItemType.ROTATION) {
    return (h("div", { class: "zoom__info-status" }, isBrowser() && h("pes-icon", { size: pesIconSizes.MICRO }, "move")));
  }
  return (h("div", { class: "zoom__info-status", onClick: props.openDialog }, isBrowser() && h("pes-icon", { size: pesIconSizes.MEDIUM }, "action_zoom_plus_stroke")));
};
export default ZoomInfoStatus;
